/* eslint-disable no-new */
import React, { useEffect } from 'react';

import { Box } from '@mui/material';
import Cookies from 'js-cookie';

import { getOhsDashboard } from 'dashboard/OhsDashboardSlice';

import { useAppSelector } from './hooks';

const googleTranslateWidget = () => {
  const scriptId = 'google-translate-script';
  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script');
    script.id = scriptId;
    script.src =
      'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    document.body.appendChild(script);

    (window as any).googleTranslateElementInit = () => {
      new (window as any).google.translate.TranslateElement(
        {
          pageLanguage: 'auto',
          autoDisplay: false, // Prevent automatic translation
          includedLanguages: 'en,ar,zh-CN,nl,tl,fr,de,hi,it,fa,pl,pt,es,sv,tr,vi,uk,th,id,ja',
        },
        'google_translate_element'
      );
    };
  }
};

function GoogleTranslate() {
  const { userLanguage } = useAppSelector(getOhsDashboard);

  useEffect(() => {
    googleTranslateWidget();
  }, []);

  const selectLanguage = (lang: string) => {
    googleTranslateWidget();
    const langSelect = document.querySelector('.goog-te-combo');
    if (langSelect) {
      // @ts-ignore
      langSelect.value = lang || ''; // Set target language
      langSelect.dispatchEvent(new Event('change')); // Trigger the translation
    }
  };

  React.useEffect(() => {
    selectLanguage(userLanguage);
  }, [userLanguage]);

  // Remove the Google Translate spinner
  // This is to prevent the spinner from showing up when the page loads
  // and to ensure it doesn't interfere with the user experience.
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
    div[class*="VIpgJd-ZVi9od-aZ2wEe"] {
      display: none !important;
    }
  `;
    document.head.appendChild(style);
  }, []);

  // Check the current googtrans cookie value
  const googtrans = Cookies.get('googtrans') || '';
  // If the cookie indicates English-to-English or auto (no translation), remove the cookie
  if (googtrans === '/en/en' || googtrans === '/auto/') {
    Cookies.set('googtrans', '', { expires: -1 }); // Remove cookie only if /en/en or /auto/
  }

  return <Box id="google_translate_element" />;
}

export default GoogleTranslate;
